// extracted by mini-css-extract-plugin
export default {"toast":"RQgV_WoKzfKA91dqdI2U__toast___"};